import _ from 'underscore';

import BenchlingConfig from 'BenchlingConfig';
import MiniMapTabState from 'molbio/tabstates/MiniMapTabState';
import {MiniMapTabStateAttributes} from 'molbio/tabstates/MiniMapTabState';
import {TabStateDefaults} from 'Navigation';
import {constructOptions} from 'settings/visibility-options/VisibilityOptions';
import * as vo from 'settings/visibility-options/VisibilityOptions';

export default class RNASequenceMiniMapTabState extends MiniMapTabState {
  defaults(): TabStateDefaults & Partial<MiniMapTabStateAttributes> {
    const visibilityOptionsConstruction: Array<vo.VisibilityOptionConstructionOption> = [
      {base: vo.MAXIMISE, visible: true, editable: false, sync: false},
      {base: vo.ANNOTATIONS, visible: true, editable: true, sync: true},
      ...(BenchlingConfig.PARTS_ENABLE_OVERLAPPING_PARTS
        ? [
            {
              base: vo.PART_ANNOTATIONS,
              visible: true,
              editable: true,
              sync: true,
            },
          ]
        : []),
      {base: vo.PRIMERS, visible: true, editable: true, sync: true},
      {base: vo.CUTSITES, visible: true, editable: true, sync: true},
      {base: vo.RNA_ORFS, visible: false, editable: true, sync: true},
      {base: vo.SEQUENCE_AXIS, visible: true, editable: true, sync: true},
      {base: vo.HOMOLOGY_REGION_AXIS, visible: false, editable: false, sync: false},
      {base: vo.DNA, visible: false, editable: false, sync: true},
      {base: vo.COMPLEMENT, visible: false, editable: false, sync: true},
      {base: vo.OVERHANGS, visible: false, editable: false, sync: true},
      {base: vo.AMINO_ACIDS, visible: false, editable: false, sync: true},
      {base: vo.INLINE_LABELS, visible: false, editable: true, sync: true},
      {base: vo.PARTS, visible: true, editable: false},
    ];
    return _(super.defaults()).extend({
      visibilityOptions: constructOptions('minimap', visibilityOptionsConstruction),
      preferenceKey: 'rna-sequence-mini-map',
    });
  }
}
